import React from 'react';

const FlowRCMLogo = ({ size = 'default', variant = 'dark', hideSubtitle = false }) => {
  const dimensions = {
  small: { svgWidth: 360, svgHeight: 60 },
  default: { svgWidth: 420, svgHeight: 60 },
  large: { svgWidth: 480, svgHeight: 60 }
};

const { svgWidth, svgHeight } = dimensions[size] || dimensions.default;
  
  // Color variants for different backgrounds
  const colors = {
    dark: {
      flow: '#ffffff',        // White Flow for dark backgrounds
      subtitle: '#99f6e4'     // Light teal subtitle for dark backgrounds
    },
    light: {
      flow: '#1e293b',        // Dark slate Flow for light backgrounds
      subtitle: '#0d9488'     // Teal-600 subtitle for light backgrounds
    }
  };
  
  const currentColors = colors[variant] || colors.dark;
  
  return (
    <svg width={svgWidth} height={svgHeight} viewBox={hideSubtitle ? "0 0 220 60" : "0 0 420 60"} xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id="flowGrad" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style={{ stopColor: '#14b8a6' }} />
          <stop offset="100%" style={{ stopColor: '#0891b2' }} />
        </linearGradient>
      </defs>
      
      {/* Waves */}
      <path d="M 15 20 Q 25 15 35 20 Q 45 25 55 20" 
        stroke="url(#flowGrad)" 
        strokeWidth="4" 
        fill="none" 
        strokeLinecap="round"/>
      
      <path d="M 15 30 Q 25 25 35 30 Q 45 35 55 30" 
        stroke="url(#flowGrad)" 
        strokeWidth="4" 
        fill="none" 
        strokeLinecap="round"
        opacity="0.6"/>
      
      <path d="M 15 40 Q 25 35 35 40 Q 45 45 55 40" 
        stroke="url(#flowGrad)" 
        strokeWidth="4" 
        fill="none" 
        strokeLinecap="round"
        opacity="0.3"/>
      
      {/* FlowRCM - Flow color changes based on variant */}
      <text x="70" y="40" fontFamily="Arial, sans-serif" fontSize="28" fontWeight="600">
        <tspan fill={currentColors.flow}>Flow</tspan>
        <tspan fill="#14b8a6">RCM</tspan>
      </text>
      
    </svg>
  );
};

export default FlowRCMLogo;